export enum EImportCustomFieldStep {
  SITES = 'sites',
  CUSTOM_FIELDS = 'customFields',
}
